(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/api/assets/javascripts/fetch-game-rooms.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/api/assets/javascripts/fetch-game-rooms.js');
"use strict";

let GameRoomStatus;
let formatCurrency;
let logger;
let jupiter;
if (svs.isServer) {
  var _trinidad$components$;
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  GameRoomStatus = require('../../../common/controller').constants.GameRoomStatus;
  formatCurrency = (_trinidad$components$ = trinidad.components.require('utils', 'format').api) === null || _trinidad$components$ === void 0 ? void 0 : _trinidad$components$.Currency;
  logger = trinidad.logger('module:bingo_react:components:api:fetchBingoGameRooms');
  jupiter = trinidad.jupiter;
} else {
  GameRoomStatus = svs.bingo_react.components.common.constants.GameRoomStatus;
  formatCurrency = svs.utils.format.Currency;
  logger = svs.core.log.getLogger('module:bingo_react:components:api:fetchBingoGameRooms');
  jupiter = svs.core.jupiter;
}
const normalizeBingoGameRoom = (cmsGame, gameRoomsResponse, req) => {
  const gameData = gameRoomsResponse.find(game => game.id === cmsGame.id);
  if (!gameData) {
    logger.info("Game ".concat(cmsGame.name, " with id ").concat(cmsGame.id, " not found on NYX response"), req);
    return null;
  }
  const now = new Date();
  const startTime = new Date(gameData.starttime);
  let status = GameRoomStatus.OPEN;

  if (dateFns.differenceInMonths(startTime, now) >= 6) {
    status = GameRoomStatus.STARTING;
  } else if (dateFns.differenceInSeconds(startTime, now) > 20 * 60) {
    status = GameRoomStatus.CLOSED;
  }
  return {
    id: gameData.id,
    badgeText: cmsGame.badgeText || null,
    host: null,
    jackpotAmount: gameData.jackpotvalue ? formatCurrency(gameData.jackpotvalue) : null,
    startTime: startTime.getTime(),
    subTitle: gameData.modelt,
    title: cmsGame.title,
    playMode: gameData.playmode,
    price: formatCurrency(gameData.price),
    players: gameData.players || '0',
    status
  };
};
const fetchBingoGameRooms = async (req, cmsGameList) => {
  try {
    let cmsGames;
    const fetchOptions = {
      method: 'GET',
      path: '/bingo/1/gamerooms'
    };
    if (svs.isServer) {
      cmsGames = cmsGameList;
      fetchOptions.req = req;
    } else {
      cmsGames = svs.bingo_react.data.cmsGames;
    }
    const result = await jupiter.callAsync(fetchOptions);
    const gamesResponseData = svs.isServer ? result.games : result.response.games;
    const normalizedResponse = cmsGames.map(game => normalizeBingoGameRoom(game, gamesResponseData, req)).filter(game => game !== null).filter(game => game.status !== GameRoomStatus.CLOSED);
    return normalizedResponse;
  } catch (e) {
    logger.error("Error fetching bingo gamerooms from NYX ".concat(e), req);
    throw e;
  }
};
if (svs.isServer) {
  module.exports = fetchBingoGameRooms;
} else {
  setGlobal('svs.bingo_react.components.api.fetchBingoGameRooms', fetchBingoGameRooms);
}

 })(window);